import React from 'react'

import { FaChevronDown, FaChevronUp } from 'react-icons/fa'

class MenuGroup extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: this.props.open,
    }
  }

  toggleMenu = () => {
    this.setState(prevState => ({
      menuOpen: !prevState.menuOpen,
    }))
  }

  componentDidMount() {
    let path = this.props.slug.replace('/design/', '').replace('/develop/', '')
    let links = this.props.children.map(e => e.key)
    links.includes(path) && this.toggleMenu()
  }

  render() {
    return (
      <ul className="menu__group">
        <div
          role="menuitem"
          tabIndex={0}
          className={'menu__category ' + (this.state.menuOpen && 'active')}
          onClick={this.toggleMenu}
          onKeyDown={this.toggleMenu}
        >
          {this.props.name}
          {this.state.menuOpen ? <FaChevronUp /> : <FaChevronDown />}
        </div>
        <div className={'menu__item-list ' + (this.state.menuOpen && 'open')}>
          {this.props.children}
        </div>
      </ul>
    )
  }
}

export default MenuGroup
